import { UTCDate } from '@date-fns/utc'
import { getLocale } from '@repo/ui/hooks'
import { format } from 'date-fns'

export const formatDate = (timestamp: number | undefined) => {
  if (!timestamp) return ''
  return format(new UTCDate(timestamp), 'yyyy-MM-dd', { locale: getLocale() })
}

export const transformDate = (date: string) => {
  return new UTCDate(date).getTime()
}